module.exports = __webpack_public_path__ + "img/bg-product.4bcb2f73.jpg";